// export const CreatedAt = (value) => {
//     if (!value) return "N/A"; // Handle empty or undefined values
  
//     const date = new Date(value);
//     if (isNaN(date.getTime())) return "Invalid Date"; // Handle invalid date values
  
//     // Extract day, month, and year
//     const day = String(date.getDate()).padStart(2, "0"); // Ensure two digits
//     const month = String(date.getMonth() + 1).padStart(2, "0"); // Months are 0-based
//     const year = date.getFullYear();
  
//     const formattedDate = `${day}-${month}-${year}`; // Format as DD-MM-YYYY
  
//     const formattedTime = date.toLocaleString("en-US", {
//       hour: "2-digit",
//       minute: "2-digit",
//       second: "2-digit",
//       hour12: true,
//     });
  
//     return `${formattedDate} ${formattedTime}`;
//   };
  
export const CreatedAt = (value,timeBoolean) => {
  if (!value) return "N/A"; // Handle empty or undefined values

  const date = new Date(value);
  if (isNaN(date.getTime())) return "Invalid Date"; // Handle invalid date values

  // Format date as DD-MM-YYYY
  const day = String(date.getDate()).padStart(2, "0");
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const year = date.getFullYear();

  // Format time as HH:MM:SS AM/PM
  let hours = date.getHours();
  const minutes = String(date.getMinutes()).padStart(2, "0");
  const seconds = String(date.getSeconds()).padStart(2, "0");
  const ampm = hours >= 12 ? "PM" : "AM";
  hours = hours % 12 || 12; // Convert to 12-hour format
  const formattedHours = String(hours).padStart(2, "0");

  const formattedDate = `${day}-${month}-${year}`;
  const formattedTime = `${formattedHours}:${minutes}:${seconds} ${ampm}`;

  return `${formattedDate} ${timeBoolean ? formattedTime :''}`;
};
